import { workshopBookingListQuerySchema } from '@chukua/common';
import { CalendarClock, ShieldAlert } from 'lucide-react';
import { Navigate } from 'react-router';
import { EmptyState } from '../../../../../shared/components/EmptyState';
import { TableSkeleton } from '../../../../../shared/components/TableSkeleton';
import { DirectoryTable } from '../../../components/DirectoryTable';
import { useDirectoryList } from '../../../hooks/use-directory-list';
import { BookingDialogs } from '../components/BookingDialogs';
import { BookingsToolbar } from '../components/BookingsToolbar';
import { buildBookingColumns } from '../components/build-booking-columns';
import { useBookingActions } from '../hooks/use-booking-actions';
import { useCanManageBookings } from '../hooks/use-can-manage-bookings';
import { useGarageOptions } from '../hooks/use-garage-options';
import { useScheduleDialogs } from '../hooks/use-schedule-dialogs';
import { listWorkshopBookings } from '../workshop-bookings.api';

/**
 * Every workshop booking, soonest first, with a workshop filter for one garage's list (gitaumoses4/chukua#169). A booking is made from a
 * truck's own Schedule tab, where its trips are in view; here they are read, moved and cancelled.
 */
export function WorkshopBookingsPage() {
  const { state, list, isRefreshing, reload } = useDirectoryList(workshopBookingListQuerySchema, listWorkshopBookings);
  const actions = useBookingActions(reload);
  const dialogs = useScheduleDialogs();
  const canManage = useCanManageBookings();
  const garages = useGarageOptions();

  if (state.status === 'forbidden') return <Navigate to="/" replace />;
  if (state.status === 'loading') return <TableSkeleton label="Loading workshop bookings" withSearch />;
  if (state.status === 'error') {
    return <EmptyState icon={ShieldAlert} title="Couldn't load workshop bookings" description="Something went wrong loading them. Try reloading the page." />;
  }

  return (
    <div className="flex flex-col gap-4">
      <DirectoryTable
        page={state.page}
        columns={buildBookingColumns({ list, actions: canManage ? { onMove: dialogs.openMove, onCancel: dialogs.openCancel } : null })}
        list={list}
        isRefreshing={isRefreshing}
        newButton={null}
        emptyIcon={CalendarClock}
        emptyTitle="No workshop bookings yet"
        emptyDescription="Book a truck into a workshop from the Schedule tab on its page, between its jobs."
        searchPlaceholder="Search by truck registration"
        noMatchTitle="No matching bookings"
        toolbar={<BookingsToolbar list={list} garages={garages} />}
      />
      <BookingDialogs dialogs={dialogs} actions={actions} />
    </div>
  );
}
